import { createSignal, createMemo, onCleanup } from "solid-js";
import { View, Text, hexColor } from "@lightningtv/solid";

// Names spelled out here rather than toLocaleDateString, whose output
// (commas, short names) differs between Android WebView versions
const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const MONTHS = ["January", "February", "March", "April", "May", "June", "July",
  "August", "September", "October", "November", "December"];

const pad = (n: number) => String(n).padStart(2, "0");

// Big 24h time with the date beside it, bottom-aligned
// (e.g. "20:27  Sunday, 1 November"), for the top left of the hotel home.
const HotelClock = (props: { x?: number; y?: number }) => {
  const [now, setNow] = createSignal(new Date());

  // Tick right when the minute changes, then every minute after that
  let interval: ReturnType<typeof setInterval> | undefined;
  const timeout = setTimeout(() => {
    setNow(new Date());
    interval = setInterval(() => setNow(new Date()), 60000);
  }, 60000 - (Date.now() % 60000));
  onCleanup(() => {
    clearTimeout(timeout);
    if (interval) clearInterval(interval);
  });

  const time = createMemo(() => `${pad(now().getHours())}:${pad(now().getMinutes())}`);
  const date = createMemo(() => {
    const d = now();
    return `${DAYS[d.getDay()]}, ${d.getDate()} ${MONTHS[d.getMonth()]}`;
  });

  return (
    <View
      x={props.x ?? 80}
      y={props.y ?? 100}
      // Lightning's flex only applies alignItems when the container has a
      // cross-axis size; without it the date sits at the top, not the bottom
      height={92}
      skipFocus
      style={{ display: "flex", flexDirection: "row", alignItems: "flexEnd", gap: 24 }}
    >
      <Text skipFocus fontSize={76} color={hexColor("#F2EFE9")}>
        {time()}
      </Text>
      <Text skipFocus fontSize={26} color={hexColor("#D0D2D8")} style={{ marginBottom: 10 }}>
        {date()}
      </Text>
    </View>
  );
};

export default HotelClock;
